import { contract_tab, info_tab, versioning_tab } from '../../../../../../views/contract/agreement';

export default {
  title: 'Détails du contrat',
  tabs: {
    [info_tab]: 'Infos',
    [contract_tab]: 'Contrat',
    [versioning_tab]: 'Versions',
  },
  sections: {
    price_info: 'Informations tarifaires',
    contact: 'Contrat actuel',
    signature_history: 'Historique des signatures',
  },
  labels: {
    not_signed: "Le contrat n'a pas encore été signé",
  },
  modals: {
    preview_contract: {
      title: 'Aperçu du contrat',
    },
    switch_to_annual: {
      title: "Passer à l'annuel",
    },
  },
  buttons: {
    save: 'Enregistrer',
    preview_and_sign: 'Aperçu et signature',
    download: 'Télécharger',
    switch_to_annual: "Passer à l'annuel",
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    failed_to_save_changes: "Échec de l'enregistrement",
    changes_got_saved: 'Modifications enregistrées',
  },
};
